import merge from "deepmerge";
import { defaultTheme } from "~/components/newsletter/newsletter-widget/styles";
export const mergeTheme = theme => merge(defaultTheme, theme);